module.exports = __webpack_public_path__ + "img/ZuCool.de787c9f.jpg";